// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 489) return "static/chunks/489.77e29b9367a4589e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"709":"7f1402134cb922c7","7013":"a1d48de9412953cb","7796":"902ab3fa6762b709","9825":"f840145070eb3758"}[chunkId] + ".js";
};